import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "product";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    //获取产品列表
    async getProductList({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingProduct/?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //新增产品
    async addProduct({ commit }, payload) {
      let result = await api.post(`/api/WeighingProduct/Add`, payload);
      return result.data;
    },
    //修改产品
    async editProduct({ commit }, payload) {
      let result = await api.put(`/api/WeighingProduct`, payload);
      return result.data;
    },
    //获取单个信息产品
    async getProductView({ commit }, payload) {
      let result = await api.get(`/api/WeighingProduct/${payload}`);
      return result.data;
    },
    //删除产品
    async deleteProduct({ commit }, payload) {
      let result = await api.delete(`/api/WeighingProduct/${payload}`);
      return result;
    },

    //新增产品规格
    async addSpec({ commit }, payload) {
      let result = await api.post(`/api/WeighingSpecies`, payload);
      return result.data;
    },
    //修改产品规格
    async editSpec({ commit }, payload) {
      let result = await api.put(
        `/api/WeighingSpecies?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //根据渔种ID查询规格
    async getSingleSpec({ commit }, payload) {
      let result = await api.get(`/api/WeighingSpecies/?fishId=${payload}`);
      return result.data;
    },
    //删除产品规格
    async deleteSpec({ commit }, payload) {
      let result = await api.delete(`/api/WeighingSpecies/${payload}`);
      return result;
    },
  },
  mutations: {},
  getters: {},
});

export default moduleName;
